var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoopLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "306px",
    height: "303px",
    viewBox: "0 0 306 303",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "primaryLogo-Copy-3",
    transform: "translate(-95.131728, -101.853553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(250.000000, 247.000000) rotate(220.000000) translate(-250.000000, -247.000000) translate(61.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "redLoop",
    transform: "translate(185.171573, 256.500000) rotate(144.000000) translate(-185.171573, -256.500000) translate(126.171573, 214.000000)",
    stroke: "#FF4081",
    strokeWidth: 58
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.097712,84.8261747 C101.205502,35.6043214 55.0106685,1.8189894e-12 0.5,1.8189894e-12",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "blueLoop",
    transform: "translate(93.671327, 208.158141) rotate(216.000000) translate(-93.671327, -208.158141) translate(20.171327, 150.658141)",
    stroke: "#00B0FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.097712,114.826175 C130.205502,65.6043214 84.0106685,30 29.5,30",
    id: "Path",
    strokeWidth: 58
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#00B0FF",
    cx: 29.7078631,
    cy: 29.6199643,
    r: 28.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "purpleLoop",
    transform: "translate(108.242712, 86.504309) rotate(288.000000) translate(-108.242712, -86.504309) translate(36.242712, 29.504309)",
    stroke: "#304FFE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.097712,113.826175 C127.205502,64.6043214 81.0106685,29 26.5,29",
    id: "Path",
    strokeWidth: 58
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-16",
    fill: "#304FFE",
    cx: 29.9880651,
    cy: 29.0687936,
    r: 28.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "greenLoop",
    transform: "translate(157.000000, 7.000000)",
    stroke: "#00CC69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.633245,113.947495 C132.741036,64.7256417 86.5462024,29.1213203 32.0355339,29.1213203",
    id: "Path",
    strokeWidth: 58
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-13",
    fill: "#00CC69",
    cx: 29.3119228,
    cy: 29.0474208,
    r: 28.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "goldLoop",
    transform: "translate(282.348778, 185.829465) rotate(72.000000) translate(-282.348778, -185.829465) translate(194.848778, 114.329465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.861708,113.843149 C129.969499,64.6212959 83.774665,29.0169745 29.2639965,29.0169745",
    id: "Path",
    stroke: "#FEC10B",
    strokeWidth: 58
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-9",
    stroke: "#FEC10B",
    fill: "#FEC10B",
    cx: 29.7913849,
    cy: 29.0766166,
    r: 28.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    stroke: "#FF4081",
    fill: "#FF4081",
    cx: 145.817593,
    cy: 113.616069,
    r: 28.5
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoopLogo);
export default __webpack_public_path__ + "static/media/loop_logo.4116c1356e7f93c6dcacbc53ba2064a7.svg";
export { ForwardRef as ReactComponent };